import React from 'react'
import cx from 'classnames'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { DropdownAnchor } from 'components/shared/ActionsDropdown/common/DropdownAnchor/DropdownAnchor'
import { DropdownMenu } from '../DropdownMenu/DropdownMenu'
import { FilterIcon } from 'components/shared/Icon/Icon'
import styles from './FilterDropdown.module.scss'

export const FilterDropdown = ({
  categoriesFilter,
  valueFilter,
  updateValueFilter,
  updateCategoryFilter,
}) => (
  <Dropdown hasArrow>
    <DropdownAnchor
      ariaLabel="filter"
      className={cx(styles.filterButton)}
      icon={FilterIcon}
      size="small"
    />
    <DropdownMenu
      categoriesFilter={categoriesFilter}
      valueFilter={valueFilter}
      updateValueFilter={updateValueFilter}
      updateCategoryFilter={updateCategoryFilter}
    />
  </Dropdown>
)
